<template>
  <div class="content">
    <img
      src="../../../assets/webActivity/couponPack/bg_blue_full.webp"
      alt=""
      class="page-bg"
    />
    <!-- 顶部标题区域 -->
    <div class="top-banner"></div>

    <!-- 购买记录 -->
    <div class="ico-record" aria-hidden="true">
      <div @click="goRule" class="rule"></div>
      <div @click="goRecord" class="record"></div>
    </div>

    <div class="activity-panel">
      <!-- 时间段选择区域 -->
      <div
        class="time-slots"
        ref="timeSlotsContainer"
        @touchstart="handleTimeSlotTouchStart"
        @touchmove="handleTimeSlotTouchMove"
      >
        <div
          v-for="(slot, index) in state.timeSlots"
          :key="index"
          :ref="el => { if (el) timeSlotRefs[index] = el }"
          :class="['time-slot', { active: slot.isActive }]"
          @click="selectTimeSlot(index)"
        >
          <div v-if="slot.status == 1" class="countdown" :class="{active: slot.isActive}">
            <div class="countdown-text">
              <span v-if="slot.h" class="frame">{{ slot.h }}</span>
              <span v-if="slot.h" class="mao">:</span>
              <span v-if="slot.m" class="frame">{{ slot.m }}</span>
              <span v-if="slot.m" class="mao">:</span>
              <span v-if="slot.s" class="frame">{{ slot.s }}</span>
            </div>
            <span class="lable">{{ slot.name }}</span>
          </div>
          <div v-else class="time-label" :class="{active: slot.isActive}">
            <span>{{ slot.name }}</span>
            <span>{{ slot.status == 0 ? `已结束`:`即将开始` }}</span>
          </div>
        </div>
      </div>

      <!-- 可用游戏列表 -->
      <div class="support-container" @click="viewGameList">
        <img src="../../../assets/webActivity/couponPack/ico_question_blue.svg" alt="">
        <span>适用于大部分0.1/0.05折游戏，查看可用游戏名单</span>
        <img src="../../../assets/webActivity/couponPack/ico_arrow_right_blue.svg" alt="">
      </div>

      <!-- 优惠券卡片区域 -->
      <div class="coupon-cards">
        <!-- 加载动画 -->
        <div v-if="state.loading" class="loading-container">
          <van-loading color="#8E6126" size="24px" vertical>
          </van-loading>
        </div>
        
        <!-- 空状态 -->
        <div v-else-if="!state.loading && state.couponCards.length === 0" class="empty-container">
          <div class="empty-content">
            <!-- <img src="../../../assets/personal/empty_img.png" class="empty-icon"/> -->
            <div class="empty-text">暂无特惠包</div>
          </div>
        </div>
        
        <!-- 优惠券卡片列表 -->
        <template v-if="!state.loading && state.couponCards.length > 0">
          <div
            v-for="(card, index) in state.couponCards"
            :key="index"
            class="coupon-card"
            @click="showCouponPopup(card)"
          >

                  <!-- 补贴标签 -->
          <div class="subsidy-tag" :class="{xianliang: card.tags != ''}">
            <span>补贴{{ formatDecimal(card.subsidy_rate) }}%</span>
          </div>
          <div class="card-content">
            <!-- 优惠券信息 -->
            <div class="coupon-info">
              <div class="total-amount">
                <div class="box">
                  <span>¥</span>
                  <span class="amount">{{ formatDecimal(card.total_coupon_money) }}</span>
                </div>
              </div>
              <div v-if="card.coupons" class="coupon-count">
                分{{ card.total_coupon_num }}张优惠券
                <img src="../../../assets/webActivity/couponPack/ico_arrow_right_blue.svg" alt="" class="arrow-icon" />
              </div>
            </div>

            <!-- 余额 -->
            <div class="gift-balance">
              <img src="../../../assets/webActivity/couponPack/ico_jb.png" alt="" class="coin-icon" />
              <span>{{ formatDecimal(card.give_money) }}余额</span>
            </div>

            <!-- 特殊标签 -->
             <div class="tag-box">
                <div class="zhe" v-if="card.discount_rules_text">
                  <span class="tag-icon">折</span>
                  <span class="van-ellipsis" >{{ card.discount_rules_text }}</span>
                </div>

                <div class="special-tag" v-if="card.tags">
                  <img src="../../../assets/webActivity/couponPack/ico_time.png" alt="" class="tag-icon" />
                  <span class="van-ellipsis" >{{ card.tags }}</span>
                </div>
             </div>


            <!-- 价格信息 -->
            <div class="price-box">
              <div class="price-info">
                <div class="current-price">
                  <span>¥</span>
                  <span>{{ formatDecimal(card.actual_amount) }}</span>
                </div>
          
                <span v-if="card.money" class="original-price">¥{{ formatDecimal(card.money) }}</span>
              </div>

              <div class="" :class="card.purchase_status == 1 ? `buy-btn` : `buy-btn2`" @click.stop="handleBuy(card)">
                <span>{{ card.purchase_text }}</span>
              </div>
            </div>

          </div>
          </div>
        </template>
      </div>

      <div class="more-coupons">
        <span class="line"></span>
        <span class="diamonds">◆◆◆</span>
        <span></span>
        <!-- <img src="../../../assets/webActivity/couponPack/ico_more_down_blue.svg" alt="" class="more-down-icon" /> -->
        <span class="line"></span>
      </div>

      <!-- 底部规则说明区域 -->
      <div class="rules-section" ref="rulesSection">
        <!-- 查看不可用游戏名单 -->
        <!-- <div class="game-list-link" @click="viewGameList">
          <img src="../../../assets/webActivity/couponPack/ico_question_blue.svg" alt="" class="tip-icon" />
          <span>查看余额不可用游戏名单</span>
          <img src="../../../assets/webActivity/couponPack/ico_arrow_right_blue.svg" alt="" class="arrow-icon" />
        </div> -->

        <!-- 规则说明 -->
        <div class="rules-content">
          <div class="rule-title">
            <img src="../../../assets/webActivity/couponPack/ico_rule_deco_left.svg" alt="" class="rule-title-icon" />
            <span>规则说明</span>
            <img src="../../../assets/webActivity/couponPack/ico_rule_deco_right.svg" alt="" class="rule-title-icon" />
          </div>
          <div class="rule-list">
            <div class="rule-item">
              <span class="rule-num">1</span>
              <span>优惠券有效期为7天，仅可在0.1折/0.05折的游戏内使用（换个别游戏无法使用）</span>
            </div>
            <div class="rule-item">
              <span class="rule-num">2</span>
              <span>购买的券包获得的余额可用于平台内任意游戏消费，在支付时选择抵扣使用；</span>
            </div>
            <div class="rule-item">
              <span class="rule-num">3</span>
              <span>优惠券包活动为限时限量活动，活动期间内不同的券包有每日限购要求，购买达到上限后，可在第二天再次进行购买；</span>
            </div>
            <div class="rule-item">
              <span class="rule-num">4</span>
              <span>优惠券包购买成功后，优惠券可在“我的优惠券”内查看，余额在个人中心查看；</span>
            </div>
            <div class="rule-item">
              <span class="rule-num">5</span>
              <span>券包为虚拟产品，一经售出无法退换，不支持退款，有任何问题可联系客服。</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  

  <CouponPackSupportGamePopup v-model:show-game="state.showGame"></CouponPackSupportGamePopup>

  <!-- 优惠券详情弹框 -->
  <van-popup
    v-model:show="state.showCouponPopup"
    round
    position="bottom"
    @close="closeCouponPopup"
  >
    <div class="coupon-popup-content">
      <h3 class="popup-title">{{ state.currentCard.name }}</h3>
      <div class="coupon-list">
        <div
          v-for="(item, index) in state.currentCard.couponList"
          :key="index"
          class="coupon-item"
        >
          <div class="coupon-bg">
            <div class="coupon-amount">
              <span class="amount-unit" v-if="item.type === 'coupon'">¥</span>
              <span class="amount-text">{{ item.money }}</span>
            </div>
            <div class="coupon-label">
              <span v-if="item.type === 'coupon'">无门槛</span>
              <span v-else>余额</span>
            </div>
            <div v-if="item.count > 1" class="coupon-count-badge">
              {{ item.count }}张
            </div>
          </div>
        </div>
      </div>

      <div class="coupon-price">
        <span class="unit">¥</span>
        <span class="price">{{ formatDecimal(state.currentCard.actual_amount)}}</span>
        <span class="jiazhi">价值¥{{ formatDecimal(state.currentCard.money)}}</span>
      </div>
      <div>

      <div class="coupon-tag">
        <div class="zhe" v-if="state.currentCard.discount_rules_text">
          <span class="tag-icon">折</span>
          <span class="van-ellipsis" >{{ state.currentCard.discount_rules_text }}</span>
        </div>

        <div class="special-tag" v-if="state.currentCard.tags">
          <img src="../../../assets/webActivity/couponPack/ico_time.png" alt="" class="tag-icon" />
          <span class="van-ellipsis" >{{ state.currentCard.tags }}</span>
        </div>

        <div v-if="state.currentCard.per_user_limit > 0" class="limit">每日限购{{state.currentCard.per_user_limit}}件</div>
      </div>


      <div :class="state.currentCard.purchase_status == 1 ? `coupon-buy-btn` : `coupon-buy-btn2`" @click.stop="handleBuy(state.currentCard)">
        {{ state.currentCard.purchase_status == 1 ? '立即抢购': state.currentCard.purchase_text }}
      </div>

      </div>

    </div>
  </van-popup>

  <!-- 支付弹框 -->
  <van-popup
    v-model:show="state.showPayPopup"
    round
    position="bottom"
  >
    <div class="pay-popup">
      <div class="pay-header">
        <img src="../../../assets/webActivity/couponPack/ico_bx.png" alt="" class="thumb" />
        <div class="title-price">
          <div class="title">{{ state.currentCard.name}}</div>
          <div class="price">¥{{ formatDecimal(state.currentCard.actual_amount || 0) }}</div>
        </div>
      </div>

      <div class="specs1">
        <div class="label" v-for="(item,index) in state.currentCard.couponList" :key="index">{{ item.name }}*{{ item.count }}</div>
      </div>

      <div class="specs">
        <div class="tags" v-if="state.currentCard.discount_rules_text">
          <span class="tag">多件优惠</span>
          <span class="rule">{{ state.currentCard.discount_rules_text }}</span>
        </div>
        <div class="limit" v-if="Number(state.currentCard.per_user_limit) > 0">
          每日限购{{ state.currentCard.per_user_limit }}件
        </div>
      </div>

      <div class="qty-row">
        <div class="price">
          <span class="unit">¥</span>
          <span class="amount">
            {{ formatDecimal(getActualTotalPrice()) }}
          </span>
          <span v-if="yhMoneyComputed > 0" class="yh">(已优惠¥{{ formatDecimal(yhMoneyComputed) }})</span>
        </div>
        <div class="qty-ctrl">
          <button class="btn" :disabled="state.payQuantity<=1" @click="decreaseQty">-</button>
          <span class="num">{{ state.payQuantity }}</span>
          <button
            class="btn"
            :disabled="Number(state.currentCard.purchase_num_oncelimit)>0 && state.payQuantity>=Number(state.currentCard.purchase_num_oncelimit)"
            @click="increaseQty"
          >+</button>
        </div>
      </div>

      <div class="pay-methods">
        <div class="title">
          支付方式
        </div>
        <div class="method" @click="selectPayMethod('alipay')">
          <div class="paytitle">
            <img src="../../../assets/webActivity/couponPack/ico_zfb.png" alt="">
            <span>支付宝</span>
          </div>

          <span class="img" :class="state.payMethod==='alipay' ? 'check' : ''"></span>
        </div>
        <div class="method" @click="selectPayMethod('wechat')">
          <div class="paytitle">
            <img src="../../../assets/webActivity/couponPack/ico_wx.png" alt="">
            <span>微信支付</span>
          </div>
          <span class="img" :class="state.payMethod==='wechat' ? 'check' : ''"></span>
        </div>
        <!-- <div class="method" @click="selectPayMethod('douyin')">
          <div class="paytitle">
            <img src="../../../assets/webActivity/couponPack/ico_dy.svg" alt="">
            <span>抖音支付</span>
          </div>
          <span class="img" :class="state.payMethod==='douyin' ? 'check' : ''"></span>
        </div> -->
      </div>

      <div class="submit-row">
        <div class="submit" @click="onConfirmPay">确认支付¥{{ formatDecimal(getActualTotalPrice()) }}</div>
      </div>
    </div>
  </van-popup>

  <!-- 购买记录弹框 -->
  <van-popup
    v-model:show="state.showRecordPopup"
    position="center"
    round
    style="background-color: transparent;"
  >
    <div class="record-container">
      <div class="record-popup">
        <div class="record-title">购买记录</div>
        <div class="record-card">
          <van-pull-refresh v-model="state.recordRefreshing" @refresh="onRecordRefresh">
            <van-list
              v-model:loading="state.recordLoading"
              :finished="state.recordFinished"
              finished-text="没有更多了"
              @load="onRecordLoad"
            >
              <div v-for="(item, idx) in state.recordList" :key="idx" class="record-item">
                <div class="record-left">
                  <div class="row time">{{ item.created_at }}</div>
                  <div class="row">
                    <div class="name">券包：{{ item.activity_name }}</div>
                  </div>
                  <div class="row">
                    <div class="order">订单：{{ item.order_no }}</div>
                    
                  </div>
                  <!-- <div class="row qty">数量：x{{ item.buy_num }}</div> -->
                </div>
                <div class="record-right">
                  <div class="price">¥{{ formatDecimal(item.actual_amount) }}</div>
                  <div class="num">数量：{{ item.buy_num }}</div>
                </div>
              </div>
              
            </van-list>
          </van-pull-refresh>
        </div>
        <div class="record-empty"></div>
      </div>
      <div class="record-close" @click="closeRecordPopup"></div>
    </div>

  </van-popup>

  
</template>

<script setup>
import { onMounted, reactive, onUnmounted, ref, nextTick, computed, watch } from "vue";
import { getQueryString } from "@/utils/location";
import { setToken } from "@/utils/auth";
import { Toast } from "vant";
import { activityAlipay, activityDypay, activityOrderLog, activityWxpay, productLists, sessionlists } from "../../../api/activity";
import {
  detect,
  randomString
} from '@/utils/device';
const { getSessionSortValue, getSessionWindow } = require("./sessionTime");

const timeSlotsContainer = ref(null);
const timeSlotRefs = ref({});
const rulesSection = ref(null);
const timeSlotTouchStart = ref({ x: 0, y: 0 });

const handleTimeSlotTouchStart = (event) => {
  const touch = event.touches && event.touches[0];
  if (!touch) return;
  timeSlotTouchStart.value = {
    x: touch.clientX,
    y: touch.clientY,
  };
};

const handleTimeSlotTouchMove = (event) => {
  const touch = event.touches && event.touches[0];
  if (!touch) return;
  const deltaX = Math.abs(touch.clientX - timeSlotTouchStart.value.x);
  const deltaY = Math.abs(touch.clientY - timeSlotTouchStart.value.y);
  if (deltaY > deltaX && event.cancelable) {
    event.preventDefault();
  }
};

const state = reactive({
  showGame:false,
  showCouponPopup: false,
  showPayPopup: false,
  showRecordPopup: false,
  currentTimeSlot: 0, // 当前选中的时间段索引（12点场）
  timeSlots: [],
  couponCards: [],
  currentCard: {},
  payQuantity: 1,
  payMethod: 'alipay',
  isRequest: false,
  loading: false, // 加载状态
  // 购买记录
  recordList: [],
  recordPage: 1,
  recordTotalPage: 1,
  recordPageSize: 10,
  recordLoading: false,
  recordFinished: false,
  recordRefreshing: false,
});

// 计算总价（自动按discount_rules实时），使用大精度（如 Big.js）计算
import Big from "big.js";
import CouponPackSupportGamePopup from "../../public/CouponPackSupportGamePopup.vue";

const goRecord = ()=>{
  state.showRecordPopup = true;
  resetRecordList();
}

const goBack = ()=>{
  window.history.back();
}

const closeRecordPopup = ()=>{
  state.showRecordPopup = false;
}

const goRule = ()=>{
  if (rulesSection.value) {
    rulesSection.value.scrollIntoView({ behavior: 'smooth', block: 'end' });
  }
}

const resetRecordList = ()=>{
  state.recordList = [];
  state.recordPage = 1;
  state.recordFinished = false;
  state.recordLoading = false;
  loadRecords();
}

const onRecordLoad = ()=>{
  if (state.recordFinished || state.recordLoading) return;
  loadRecords();
}

const onRecordRefresh = ()=>{
  state.recordRefreshing = true;
  state.recordPage = 1;
  state.recordFinished = false;
  state.recordList = [];
  setTimeout(()=>{
    loadRecords();
  }, 300);
}

const loadRecords = ()=>{
  state.recordLoading = true;

  activityOrderLog({
    pagecode: state.recordPage,
    username: getQueryString('username'),
  }).then(response=>{
    if (response.data.code == 1) {
      state.recordTotalPage = response.data.data.total_page;
      state.recordList = state.recordList.concat(response.data.data.lists);

      if (state.recordPage >= state.recordTotalPage) {
        state.recordFinished = true;
      }

      state.recordPage = response.data.data.now_page;
      state.recordPage++;
    }
  }).finally(()=>{
    state.recordRefreshing = false;
  });
}

const getActualTotalPrice = () => {
  const q = Big(state.payQuantity || 0);
  const discountRules = state.currentCard.discount_rules || {};
  const actualAmount = Big(state.currentCard.actual_amount || 0);

  let pay = actualAmount.times(q);
  if (
    discountRules &&
    Object.keys(discountRules).length > 0
  ) {
    // 找到最大可用折扣
    const steps = Object.entries(discountRules)
      .map(([num, rate]) => ({ num: Number(num), rate: Number(rate) }))
      .sort((a, b) => a.num - b.num);
    let bestStep = null;
    for (let i = 0; i < steps.length; i++) {
      if (q.gte(steps[i].num)) bestStep = steps[i];
    }
    if (bestStep) {
      pay = actualAmount.times(q).times(Big(bestStep.rate));
    }
  }
  return Number(pay.toFixed(2));
};

// 计算优惠金额的计算属性（使用大精度计算，原价-总价方式）
const yhMoneyComputed = computed(() => {
  const q = Big(state.payQuantity || 0);
  const discountRules = state.currentCard.discount_rules || {};
  const actualAmount = Big(state.currentCard.actual_amount || 0);

  if (
    !discountRules ||
    typeof discountRules !== "object" ||
    Object.keys(discountRules).length === 0
  ) {
    return 0;
  }

  // 找到最大可用折扣
  const steps = Object.entries(discountRules)
    .map(([num, rate]) => ({ num: Number(num), rate: Number(rate) }))
    .sort((a, b) => a.num - b.num);
  let bestStep = null;
  for (let i = 0; i < steps.length; i++) {
    if (q.gte(steps[i].num)) bestStep = steps[i];
  }
  if (!bestStep) return 0;
  // 用大精度计算总原价和总现价之差
  const totalOrigin = actualAmount.times(q);
  const totalCurrent = (() => {
    if (bestStep) {
      return actualAmount.times(q).times(Big(bestStep.rate));
    }
    return totalOrigin;
  })();
  const diff = totalOrigin.minus(totalCurrent);
  return diff.gt(0) ? Number(diff.toFixed(2)) : 0;
});


let countdownTimer = null;

const BEIJING_OFFSET_MINUTES = 8 * 60;

const getBeijingNow = () => {
  const now = new Date();
  return new Date(
    now.getTime() + (BEIJING_OFFSET_MINUTES + now.getTimezoneOffset()) * 60 * 1000
  );
};

onMounted(() => {
  if (getQueryString("token")) {
    setToken(getQueryString("token"));
  }

  sessionlists({ uid: getQueryString("uid"), token: getQueryString("token") }).then(res => {
    console.log(res.data);
    refreshTime(res.data)
  });

});

const formatDecimal = (num) => {
  // 双重解析确保输入安全
  const parsed = Number.parseFloat(num);
  
  // 智能零值检测系统
  return parsed % 1 === 0 
    ? parsed.toFixed(0)  // 整数模式
    : parsed.toString().replace(/(\.\d*?[1-9])0+$/, '$1'); // 小数模式
}

const refreshTime = (list)=>{

    const now = getBeijingNow();

    // 按时间先后排序
    const timeSlots = list.slice().sort((a, b) => {
      return getSessionSortValue(a.time) - getSessionSortValue(b.time);
    });

    // 找出当前活动场次
    let activeIndex = null;

    // 处理每个场次, 并根据当前时间设置status: 1=已开始, 2=未开始, 0=已结束
    timeSlots.forEach((slot, i) => {
      const { start, end } = getSessionWindow(timeSlots, i, now);

      console.log(start, end)

      if (now >= start && now < end) {
        // 活动已开始
        activeIndex = i;
        slot.status = 1;
        slot.isActive = true;
        // 倒计时到下一场
        let diff = Math.max(0, Math.floor((end - now) / 1000));
        let h = Math.floor(diff / 3600).toString().padStart(2, "0");
        let m = Math.floor((diff % 3600) / 60).toString().padStart(2, "0");
        let s = (diff % 60).toString().padStart(2, "0");
        slot.h = h;
        slot.m = m;
        slot.s = s;
        slot.countdown = `${h}:${m}:${s}`;
      } else if (now < start) {
        // 活动未开始
        slot.status = 2;
        slot.isActive = false;
        slot.h = "00";
        slot.m = "00";
        slot.s = "00";
        slot.countdown = "";
      } else {
        // 活动已结束
        slot.status = 0;
        slot.isActive = false;
        slot.h = "00";
        slot.m = "00";
        slot.s = "00";
        slot.countdown = "";
      }
    });

    if(timeSlots.length > 0){
      if(activeIndex == null){
        activeIndex = timeSlots.findIndex((slot, i) => now < getSessionWindow(timeSlots, i, now).start);
        if (activeIndex < 0) activeIndex = 0;
        timeSlots[activeIndex].isActive = true;
      }
      state.timeSlots = timeSlots;
      state.currentTimeSlot = activeIndex;


      // 开始倒计时
      startCountdown();
      // 初始化时滚动到当前选中的时间段
      nextTick(() => {
        scrollToTimeSlot(state.currentTimeSlot);
      });

      // 获取商品信息
      getList()
    }

}

const getList = ()=>{
  state.loading = true;
  productLists({ uid: getQueryString("uid"), token: getQueryString("token"),session_id: state.timeSlots[state.currentTimeSlot].id }).then(res=>{
    console.log(res.data)
    if(res.data.code == 1){
      var tempList = res.data.data.products
      // 先排序：按 actual_amount 升序
      tempList.sort((a, b) => Number(a.actual_amount) - Number(b.actual_amount));

      tempList.forEach(item =>{


        // 0 已结束 1 进行中 2 未开始
        var status = state.timeSlots[state.currentTimeSlot].status 
        if(status == 0){
          item.purchase_status = -1
          item.purchase_text = "已结束"
        }else if(status == 2){
          item.purchase_status = -1
          item.purchase_text = "未开始"
        }

        item.total_coupon_money = item.coupons
          .reduce((sum, coupon) => sum + (Number(coupon.coupon_money) || 0) * (Number(coupon.num) || 1), 0);

        // 新增字段，统计所有优惠券的总数量
        item.total_coupon_num = item.coupons
          .reduce((sum, coupon) => sum + (Number(coupon.num) || 0), 0);

        // 新增字段，限量则单次购买1个，非限量单次购买10个
        if(item.tags){
          item.purchase_num_oncelimit = 1
        }else{
          item.purchase_num_oncelimit = 10;
        }


        // discount_rules结构如：{"5":"0.98","10":"0.95"}
        // 判断非空对象
        if (
          item.discount_rules && 
          typeof item.discount_rules === 'object' && 
          Object.keys(item.discount_rules).length > 0
        ) {
          const rules = item.discount_rules;
          item.discount_rules_text = Object.entries(rules)
            .map(([count, discount]) => {
              // discount如0.98，显示为9.8折而不是98折
              let discountNum = Number(discount);
              let discountStr = (discountNum * 10) % 1 === 0
                ? (discountNum * 10).toFixed(0)
                : (discountNum * 10).toFixed(1);
              return `${count}件${discountStr}折`;
            })
            .join(' ');
        } else {
          item.discount_rules_text = "";
        }

        // 跟据coupons构建couponList
        const tempCouponList = []
        item.coupons.forEach(item2 => {
          tempCouponList.push({
            type: 'coupon',
            name: item2.name,
            money: formatDecimal(item2.coupon_money),
            count: item2.num,
          })
        })


        // 添加余额（如果有）
        if (item.give_money && Number(item.give_money) > 0) {
          tempCouponList.push({
            type: 'balance',
            name: formatDecimal(item.give_money) + '余额',
            money: formatDecimal(item.give_money),
            count: 1,
          });
        }
        item.couponList = tempCouponList;


      })

      state.couponCards = tempList
    } else {
      state.couponCards = []
    }
    state.loading = false;
  }).catch(err => {
    console.error(err);
    state.couponCards = [];
    state.loading = false;
  })
}

onUnmounted(() => {
  if (countdownTimer) {
    clearInterval(countdownTimer);
  }
});

// 滚动到指定时间段并居中
const scrollToTimeSlot = (index) => {
  if (!timeSlotsContainer.value || !timeSlotRefs.value[index]) {
    return;
  }
  
  const container = timeSlotsContainer.value;
  const targetElement = timeSlotRefs.value[index];
  
  // 计算需要滚动的距离（使目标元素居中）
  const containerWidth = container.offsetWidth;
  const targetWidth = targetElement.offsetWidth;
  const targetOffsetLeft = targetElement.offsetLeft;
  
  // 计算居中位置
  let scrollLeft = targetOffsetLeft - (containerWidth - targetWidth) / 2;
  
  // 边界处理：确保不会滚动超出范围
  const maxScrollLeft = container.scrollWidth - containerWidth;
  scrollLeft = Math.max(0, Math.min(scrollLeft, maxScrollLeft));
  
  // 平滑滚动
  container.scrollTo({
    left: scrollLeft,
    behavior: 'smooth'
  });
};

// 选择时间段
const selectTimeSlot = (index) => {
  state.couponCards = []
  state.currentTimeSlot = index;
  state.timeSlots.forEach((slot, i) => {
    slot.isActive = i === index;
  });
  // 滚动到选中的时间段并居中
  nextTick(() => {
    scrollToTimeSlot(index);
  });
  // 获取新场次的数据
  getList()
};

// 开始倒计时
const startCountdown = () => {
  countdownTimer = setInterval(() => {
    // const activeSlotList = state.timeSlots.filter((slot) => slot.status == 1);
    // activeSlotList.forEach(activeSlot => {
    //   if (activeSlot && activeSlot.countdown) {
    //   // 解析倒计时字符串 "09:22:40"
    //   const [hours, minutes, seconds] = activeSlot.countdown.split(":").map(Number);
    //   let totalSeconds = hours * 3600 + minutes * 60 + seconds;

    //   if (totalSeconds > 0) {
    //     totalSeconds--;
    //     const h = Math.floor(totalSeconds / 3600)
    //       .toString()
    //       .padStart(2, "0");
    //     const m = Math.floor((totalSeconds % 3600) / 60)
    //       .toString()
    //       .padStart(2, "0");
    //     const s = (totalSeconds % 60).toString().padStart(2, "0");
    //     activeSlot.h = h
    //     activeSlot.m = m
    //     activeSlot.s = s
    //     activeSlot.countdown = `${h}:${m}:${s}`;
    //   } else {
    //     // 倒计时结束，切换到下一个时间段
    //     activeSlot.status = 0;
    //     activeSlot.isActive = false;
    //     activeSlot.h = "00";
    //     activeSlot.m = "00";
    //     activeSlot.s = "00";
    //     activeSlot.countdown = "";
    //     // 这里可以添加切换到下一个时间段的逻辑

    //     clearInterval(countdownTimer);
    //     countdownTimer = null
    //     refreshTime(state.timeSlots)
    //   }
    // }
    // })





  const now = getBeijingNow();
    const selectedSlot = state.timeSlots[state.currentTimeSlot];
    const selectedWindow = getSessionWindow(state.timeSlots, state.currentTimeSlot, now);
    if ((selectedSlot.status == 1 && (now < selectedWindow.start || now >= selectedWindow.end))
      || (selectedSlot.status == 2 && now >= selectedWindow.start && now < selectedWindow.end)) {
      clearInterval(countdownTimer);
      countdownTimer = null;
      refreshTime(state.timeSlots);
      return;
    }

    // 处理每个场次, 并根据当前时间设置status: 1=已开始, 2=未开始, 0=已结束
    state.timeSlots.forEach((slot, i) => {
      if(slot.status == 1){
        const { end } = getSessionWindow(state.timeSlots, i, now);
          let diff = Math.max(0, Math.floor((end - now) / 1000));

          if(diff > 0){
            let h = Math.floor(diff / 3600).toString().padStart(2, "0");
            let m = Math.floor((diff % 3600) / 60).toString().padStart(2, "0");
            let s = (diff % 60).toString().padStart(2, "0");
            slot.h = h;
            slot.m = m;
            slot.s = s;
            slot.countdown = `${h}:${m}:${s}`;
          }else{
            // 倒计时结束，切换到下一个时间段
            slot.status = 0;
            slot.isActive = false;
            slot.h = "00";
            slot.m = "00";
            slot.s = "00";
            slot.countdown = "";
            // 这里可以添加切换到下一个时间段的逻辑

            clearInterval(countdownTimer);
            countdownTimer = null
            refreshTime(state.timeSlots)
          }


      }
      
    });

  }, 1000);
};

// 购买优惠券包
const handleBuy = (card) => {

  if(card.purchase_status == -1){
    Toast('活动' + card.purchase_text)
    return;
  }

  if(card.purchase_status == 0){
    Toast(card.purchase_text)
    return;
  }

  // 打开支付弹框
  state.currentCard = card;
  state.payQuantity = 1;
  state.payMethod = 'alipay';
  state.showCouponPopup = false;
  state.showPayPopup = true;
};

// 查看不可用游戏名单
const viewGameList = () => {
  state.showGame = true
};

// 显示优惠券弹框
const showCouponPopup = (card) => {
  state.currentCard = card;
  state.showCouponPopup = true;
};

// 关闭优惠券弹框
const closeCouponPopup = () => {
  state.showCouponPopup = false;
};

// 支付弹框相关
const increaseQty = () => {
  const limit = Number(state.currentCard.per_user_limit) || 0;
  if (limit > 0 && state.payQuantity >= limit) {
    Toast(`最多可购${limit}件`);
    return;
  }
  state.payQuantity++;
};

const decreaseQty = () => {
  if (state.payQuantity > 1) {
    state.payQuantity--;
  }
};

const selectPayMethod = (method) => {
  state.payMethod = method;
};

// 确认支付
const onConfirmPay = () => {
  console.log(state.currentCard)

  if(!getQueryString('username')){
    Toast("请先登录")
    return
  }

  if(state.isRequest){
    return
  }
  state.isRequest = true
  if(state.payMethod == 'alipay'){
    activityAlipay({
      product_id:state.currentCard.id,
      session_id:state.currentCard.session_id,
      buy_num:state.payQuantity,
      username:getQueryString('username'),
      order_no:'001_thb_zfb_'+randomString(5) + Date.now(),
    }).then(response=>{
      console.log(response)
      if(response.data.code == 1){
        if(document.getElementById('alipay')!=null){
          document.getElementById('alipay').parentNode.removeChild(document.getElementById('alipay'))
        }
        const div = document.createElement('div');
        div.id='alipay'
        div.innerHTML = response.data.data;
        console.log(div)
        document.body.appendChild(div);
        document.forms[0].submit();
      }else{
        Toast(response.data.msg)
      }
    }).finally(()=>{
      state.isRequest = false
    })
  }else if(state.payMethod == 'douyin'){
    activityDypay({
      product_id:state.currentCard.id,
      session_id:state.currentCard.session_id,
      buy_num:state.payQuantity,
      username:getQueryString('username'),
      order_no:'001thbdy'+randomString(5) + Date.now(),
    }).then(response=>{
      console.log(response)
      if(response.data.code == 1){
        if (detect() == "android" || detect() == "harmony") {
          document.location.href = response.data.data.pay_url;
        } else {
          window.parent.postMessage(
            { url: response.data.data.pay_url, eventType: "dyPayH5" },
            "*"
          );
        }

      }else{
        Toast(response.data.msg)
      }
    }).finally(()=>{
      state.isRequest = false
    })
  }else{
    activityWxpay({
      product_id:state.currentCard.id,
      session_id:state.currentCard.session_id,
      buy_num:state.payQuantity,
      username:getQueryString('username'),
      order_no:'001_thb_wx_'+randomString(5) + Date.now(),
    }).then(response=>{
      console.log(response)
      if(response.data.code == 1){
        if (detect() == "android" || detect() == "harmony") {
          document.location.href = response.data.data;
        } else {
          window.parent.postMessage(
            { url: response.data.data, eventType: "wxPayH5" },
            "*"
          );
        }

      }else{
        Toast(response.data.msg)
      }
    }).finally(()=>{
      state.isRequest = false
    })
  }
  

};
</script>

<style src="../../../styles/removeVantcell.css"></style>
<style>
html,
body {
  background: #85c2fd;
}

#app {
  background: #85c2fd;
}
</style>
<style scoped>
/* :deep(.van-popup) {
  background-color: red;
} */
/* .record-container {
  background-color: transparent;
} */

.support-container {
  display: flex;
  align-items: center;
  height: 80px;
  margin-left: 32px;
  margin-right: 32px;
  background-color: #FFFBE5;
  border-radius: 100px;
  padding-left: 24px;
  padding-right: 24px;
  margin-top: 30px;
}

.support-container img {
  width: 28px;
  height: 28px;

}

.support-container span {
  font-size: 24px;
  color: #822813;
  margin: 0 8px;
  flex: 1;
}

.record-close{ 
  width: 64px; 
  height: 64px; 
  background-image:url('../../../assets/webActivity/couponPack/ico_record_close.png'); 
  background-size: 100% 100%;
  background-repeat: no-repeat;
  margin: 16px auto 0; 
}

.record-popup{ 
  position: relative; 
  width: 630px;
  height: 752px; 
  background-image:url('../../../assets/webActivity/couponPack/ico_record_bg.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
}
.record-card{ 
  flex: 1;
  position:relative; 
  margin: 0 auto; 
  width: 100%;
  border-radius: 24px; 
  padding: 20px 24px 0px;
  overflow-y: auto;
}
.record-empty{
  height: 36px;
}
.record-title{ 
  text-align:center; 
  font-size: 32px; 
  font-weight: bold; 
  margin-bottom: 8px;
  padding: 20px 24px 0px; 
}
.record-item{ 
  padding: 16px 4px; 
  border-bottom: 1px solid #f0f0f0; 
  display: flex;
  align-items: center;
}
.record-left{
  flex: 1;
  margin-right: 10px;
}
.record-right {
  display: flex;
  flex-direction: column;
  align-items: end;
  flex-shrink: 1;
}   
.record-right .num {
  color: #666;
  font-size: 22px;
  margin-top: 6px;
}
.record-item .row{ display:flex; justify-content: space-between; align-items:center; font-size:24px; color:#585858; }
.record-item .time{ color:#666; font-size:24px; margin-bottom:6px; }
.record-item .name{ color:#333; font-weight:600;font-size: 24px; }
.record-item .order{
  color: #666;
}
.record-item .status{ font-weight:600; }
.record-item .status.success{ color:#10c06f; }
.record-item .status.cancel{ color:#999; }
.record-item .price{ color:#ff4444; font-weight:bold; }
.record-item .qty{ color:#999; }



.content {
  height: 100vh;
  overflow: auto;
  background: #FDB25F;
}

.ico-record {
  position: absolute;
  top: 150px;
  right: 0px;
  z-index: 10;
  width: 64px;
  height: 262px;
  background-image: url('../../../assets/webActivity/couponPack/ico_record_i.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
}
.ico-record .rule{
  width: 100%;
  height: 100px;
}
.ico-record .record{
  flex: 1;
  width: 100%;
}
/* 顶部标题区域 */
.top-banner {
  width: 100%;
  position: relative;
}

.bg-top {
  width: 100%;
  display: block;
}

/* 时间段选择区域 */
.time-slots {
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
  padding: 0 32px;
  margin-top: -96px;
  gap: 12px;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  /* 隐藏滚动条 */
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
}

.time-slots::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Opera */
}

.time-slot {
  flex: 0 0 auto;
  min-width: 180px;
  height: 132px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  color: #333333;
  position: relative;
  transition: all 0.3s;
  cursor: pointer;
  white-space: nowrap;
  background-image: url('../../../assets/webActivity/couponPack/bg_uncheck.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  padding-bottom: 20px;
}

.time-slot.active {
  background-image: url('../../../assets/webActivity/couponPack/bg_check.png');

}

.countdown {
  display: flex;
  flex-direction: column;
  font-size: 28px;
  text-align: center;
  color: #8e612699;
}
.countdown .lable {
  margin-top: 8px;
}
.countdown.active{
  color: #fff;
}

.time-icon {
  width: 32px;
  height: 32px;
}

.countdown .countdown-text {
  font-size: 22px;
  color: #fff;
  font-weight: bold;
}

.countdown .countdown-text .frame {
  height: 32px;
  border-radius: 6px;
  background-color: #8e612699;
  padding-left: 2px;
  padding-right: 2px;

}

.countdown .countdown-text .mao{
  color: #8e612699;
  font-weight: bolder;
  font-size: 32px;
  line-height: 32px;
  padding-left: 3px;
  padding-right: 3px;
}

.countdown.active .countdown-text {
  font-size: 22px;
  color: #F45B4B;
  font-weight: bold;
}

.countdown.active .countdown-text .frame {
  height: 32px;
  border-radius: 6px;
  background-color: #FFF7EA;
  padding-left: 2px;
  padding-right: 2px;

}

.countdown.active .countdown-text .mao{
  color: #FFFFFF;
  font-weight: bolder;
  font-size: 32px;
  line-height: 32px;
  padding-left: 3px;
  padding-right: 3px;
}


.time-label {
  display: flex;
  flex-direction: column;
  font-size: 28px;
  text-align: center;
  color: #8e612699;
}

.time-label span:first-of-type{
  font-size: 32px;
  font-weight: bold;
}

.time-label.active{
  color: white;
}


/* 优惠券卡片区域 */
.coupon-cards {
  padding: 0 30px 30px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  margin-top: 12px;
  min-height: 200px;
}

/* 加载容器 */
.loading-container {
  grid-column: 1 / -1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 80px 0;
  min-height: 250px;
}

/* 空状态容器 */
.empty-container {
  grid-column: 1 / -1;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 250px;
  /* padding: 120px 0; */
  /* min-height: 300px; */
}

.empty-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.empty-icon {
  width: 100%;
  margin-bottom: 24px;
}

.empty-text {
  font-size: 28px;
  color: #8E6126;
  text-align: center;
  font-weight: 500;
}

.coupon-card {
  position: relative;
  overflow: hidden;
}


.card-content {
  position: relative;
  padding: 20px;
  display: flex;
  border-radius: 40px;
  background: #fff;
  flex-direction: column;
  margin-top: 40px;
}

/* 补贴标签 */
.subsidy-tag {
  position: absolute;
  top: 20px;
  left: 4px;
  z-index: 1;
  background-image: url('../../../assets/webActivity/couponPack/ico_bt1.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  color: #ffffff;
  font-size: 20px;
  padding: 8px 18px 18px 16px;
  font-weight: bold;
  border-radius: 8px;
}

.subsidy-tag.xianliang{
  background-image: url('../../../assets/webActivity/couponPack/ico_bt2.png');
}

/* 优惠券信息 */
.coupon-info {
  width: 100%;
  height: 210px;
  background-image: url('../../../assets/webActivity/couponPack/bg_coupon.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
}

.total-amount {
  height: 142px;
  font-weight: bold;
  color: #FF6666;
  display: flex;
  justify-content: center;
  align-items: center;
}
.total-amount .box {
  display: flex;
  align-items: baseline;

}
.total-amount .amount{
  font-size: 72px;
}

.coupon-count {
  font-size: 24px;
  color: #8E6126;
  height: 68px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
}

.arrow-icon {
  width: 20px;
  height: 20px;
}

/* 余额 */
.gift-balance {
  width: 100%;
  height: 56px;
  border: 2px solid #FFF1D5;
  background-color: #FFF7EA;
  border-radius: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  font-size: 22px;
  color: #FF6666;
  margin-top: 8px;
  cursor: pointer;
}

.coin-icon {
  width: 28px;
  height: 28px;
}

.tag-box{
  display: flex;
  flex-wrap: wrap;
  margin-top: 8px;
  gap: 8px;
}



/* 特殊标签 */
.special-tag {
  display: flex;
  align-items: center;
  height: 36px;
  gap: 2px;
  background: #ff4444;
  color: #ffffff;
  font-size: 22px;
  padding: 0px 8px;
  border-radius: 8px;
  align-self: flex-start;
  overflow: hidden;
  max-width: 100%;
  max-lines: 1;
  margin-top: 6px;
}
.special-tag span {
  max-lines: 1;
}

.coupon-tag .special-tag {
  margin-top: 0;
  margin-right: 8px;
}
 .zhe {
  display: flex;
  align-items: center;
  height: 36px;
  font-size: 22px;
  border-radius: 8px;
  align-self: flex-start;
  overflow: hidden;
  max-width: 100%;
  max-lines: 1;
  margin-top: 6px;
  border: 2px solid #FE4D50;
  color: #FE4D50;
  background-color: white;
}
 .zhe img {
  height: 100%;
  width: 36px;
}
 .zhe span {
  padding-left: 14px;
  padding-right: 14px;
}

.tag-icon {
  width: 24px;
  height: 24px;
}
 .zhe {
  display: flex;
}
 .zhe .tag-icon {
  height: 100%;
  width: auto;
  background-color: #FE4D50;
  color: white;
  font-size: 22px;
}

.price-box{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
}


/* 价格信息 */
.price-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: baseline;
}

.current-price {
  font-size: 40px;
  line-height: 56px;
  font-weight: bold;
  color: #ff4444;
}
.current-price span:first-of-type{
  font-size: 28px;
}

.original-price {
  font-size: 28px;
  color: #999999;
  text-decoration: line-through;
}

/* 购买按钮 */
.buy-btn {
  width: 132px;
  height: 72px;
  background: #111111;
  border-radius: 198px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s;
  border: 2px solid #FF4A86;
}

.buy-btn2 {
  width: 132px;
  height: 72px;
  background: #D9D9D9;
  border-radius: 198px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s;
}

.buy-btn2 span {
  font-size: 24px;
  color: #999999;
  font-weight: bold;
}

.buy-btn:active {
  transform: scale(0.95);
  opacity: 0.8;
}

.buy-btn span {
  font-size: 24px;
  color: #F0FE69;
  font-weight: bold;
}

/* 底部规则说明区域 */
.rules-section {
  padding: 0 30px 40px;
}

.game-list-link {
  background: #fff8e1;
  border-radius: 100px;
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 20px;
  color: #333333;
  cursor: pointer;
  height: 80px;
  padding: 0 24px;
  color: #822813;
}
.game-list-link span{
  flex: 1;
  
}

.tip-icon {
  width: 32px;
  height: 32px;
}

.rules-content {
  margin-top: 24px;
}

.rule-image {
  width: 100%;
  display: block;
}

/* 优惠券弹框样式 */
.coupon-popup-content {
  padding: 0 32px 74px;
  display: flex;
  flex-direction: column;
  height: 100%;
  background: linear-gradient(179.76deg, #fffbe5 0.21%, #ffffff 41.02%);
}

.popup-title {
  text-align: center;
  font-size: 32px;
  font-weight: bold;
  color: #000000;
  margin: 20px 0;
}

.coupon-list {
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: flex-start;
  align-content: flex-start;
  padding-bottom: 20px;
}

.coupon-item {
  width: calc((100% - 40px) / 3);
  min-width: 0;
  flex-shrink: 0;
}

.coupon-bg {
  position: relative;
  width: 100%;
  aspect-ratio: 1;
  background-image: url('../../../assets/webActivity/couponPack/bg_coupon2.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  border-radius: 16px;
}

.coupon-amount {
  display: flex;
  align-items: baseline;
  justify-content: center;
  padding-top: 60px;
  color: #FF6666;
  font-weight: bold;
  flex: 1;
  width: 100%;
  
}

.coupon-amount .amount-text {
  font-size: 60px;
  line-height: 1;
  font-weight: bold;
}

.coupon-amount .amount-unit {
  font-size: 32px;
  margin-right: 4px;
}

.coupon-label {
  font-size: 22px;
  color: #8E6126;
  text-align: center;
  height: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 15px;
}

.coupon-count-badge {
  position: absolute;
  top: 16px;
  right: 20px;
  color: #fff;
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  height: 34px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
  min-width: 68px;
  padding-left: 12px;
  padding-right: 12px;
  border-radius:  20px 20px 20px 0px;
  background: linear-gradient(270deg, #ff67ab 0%, #fe5f2c 100%);
}

.coupon-price {
  display: flex;
  align-items: baseline;
}

.coupon-price .unit {
  font-size: 28px;
  color: #FF6666;
  font-weight: bold;
}
.coupon-price .price {
  font-size: 40px;
  margin-right: 16px;
  color: #FF6666;
  font-weight: bold;
}
.coupon-price .jiazhi {
  font-size: 28px;
  color: #999999;
  line-height: 1.8;
}
.coupon-tag {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-top: 12px;
}
.coupon-tag .zhe {
  margin: 0px;
  margin-right: 8px;
}
.coupon-tag .limit {
  font-size: 22px;
  height: 36px;
  padding: 0 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px solid #999999;
  color: #585858;
  border-radius: 6px;
}

.coupon-buy-btn {
  width: 100%;
  height: 108px;
  background: #111111;
  border-radius: 198px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s;
  border: 2px solid #FF4A86;
  color: #fff;
  font-weight: bold;
  margin-top: 46px;
}

.coupon-buy-btn2 {
  width: 100%;
  height: 108px;
  background: #D9D9D9;
  border-radius: 198px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s;
  color: #999999;
  font-weight: bold;
  margin-top: 46px;
}

/* ====== 支付弹框 ====== */
.pay-popup{
  padding: 32px 32px calc(32px + env(safe-area-inset-bottom));
  background: #fff;
}
.pay-header{
  display: flex;
  align-items: center;
  gap: 24px;
  margin-bottom: 12px;
}
.pay-header .thumb{
  width: 140px;
  height: 140px;
  border-radius: 20px;
  background: #f5f5f5;
  object-fit: cover;

}
.pay-header .title-price{
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.pay-header .title{
  font-size: 32px;
  color: #000000;
}
.pay-header .price{
  font-size: 28px;
  color: #999999;
}

.specs,.specs1{
  display: flex;
  gap: 12px;
  align-items: center;
  flex-wrap: wrap;
}
.specs{
  margin-top: 14px;
}
.specs1 {
  margin-top: 20px;
}
.specs1 .label {
  font-size: 24px;
  color: #585858;
  height: 40px;
  padding-left: 12px;
  padding-right: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #F4F4F4;
  border-radius: 6px;
}
.specs .tags{
  display: flex;
  align-items: center;
  border: 2px solid #FE4D50;
  overflow: hidden;
  border-radius: 8px;
}
.specs .tag{
  font-size: 22px;
  color: #fff;
  background: #ff5a54;
  padding: 2px 8px;
}
.specs .rule{
  font-size: 22px;
  color: #fe4d50;
  background: #fff;
  padding: 2px 10px;
}
.specs .limit{
  font-size: 22px;
  color: #585858;
  border-radius: 6px;
  border: 2px solid #999999;
  padding-left: 12px;
  padding-right: 12px;
}

.qty-row{
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 28px 0;
  border-bottom: 1px solid #f2f2f2;
}

.qty-row .price {
  display: flex;
  align-items: baseline;
  letter-spacing: 1px;
}
.qty-row .price .unit {
  font-size: 28px;
  font-weight: bold;
  color: #FE5064;
}
.qty-row .price .amount {
  font-size: 40px;
  font-weight: bold;
  color: #FE5064;
}
.qty-row .price .yh {
  font-size: 28px;
  color: #FE5064;
  margin-left: 4px;
}

.qty-row > span{
  font-size: 28px;
  color: #111;
}
.qty-ctrl{
  display: inline-flex;
  align-items: center;
  gap: 16px;
}
.qty-ctrl .btn{
  width: 72px;
  height: 60px;
  border-radius: 12px;
  border: none;
  background: #f5f5f5;
  font-size: 32px;
  color: #111;
}
.qty-ctrl .btn:disabled{
  opacity: .5;
}
.qty-ctrl .num{
  min-width: 40px;
  text-align: center;
  font-size: 32px;
  color: #111;
}

.pay-methods{
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 20px 0 40px;
}

.pay-methods .title{
  color: #000000;
  font-size: 28px;
  font-weight: bold;
  margin-top: 8px;
  margin-bottom: 8px;
}

.pay-methods .method{
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100px;
  padding: 0 32px;
  background: #F7F8FA;
  border-radius: 16px;
  font-size: 28px;
  color: #333;
}
.pay-methods .method .paytitle {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #333;
  font-weight: bold;
  gap: 20px;
}
.pay-methods .method img{
  width: 60px;
  height: 60px;
}
.pay-methods .method .img{
  width: 32px;
  height: 32px;
  background: url('../../../assets/webActivity/couponPack/ico_uncheck.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.pay-methods .img.check{
  background: url('../../../assets/webActivity/couponPack/ico_check.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.submit-row{
  position: sticky;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  background: #fff;
  padding-bottom: env(safe-area-inset-bottom);
}
.submit-row .amount{
  flex: 1;
  font-size: 36px;
  color: #ff4444;
  font-weight: bold;
}
.submit-row .submit{
  width: 100%;
  height: 100px;
  border-radius: 48px;
  background: linear-gradient(180deg, #59c9ff 0%, #176df1 100%);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 30px;
  font-weight: bold;
  letter-spacing: 1px;
}

/* ====== Blue coupon pack redesign ====== */
.content {
  min-height: 100vh;
  height: 100vh;
  overflow: auto;
  position: relative;
  background-color: #85c2fd;
  color: #13345b;
}

.page-bg {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 0;
  width: 100%;
  height: auto;
  display: block;
  pointer-events: none;
  user-select: none;
}

.top-banner {
  width: 100%;
  height: 620px;
  position: relative;
  overflow: hidden;
  z-index: 1;
  background: transparent;
}

.top-banner::before {
  display: none;
}

.bg-top {
  display: none;
}

.top-nav {
  display: none;
}

.nav-back,
.nav-pill {
  border: 0;
  background: transparent;
  padding: 0;
  cursor: pointer;
}

.nav-back {
  width: 52px;
  height: 52px;
  position: relative;
  flex: 0 0 120px;
}

.nav-back::before {
  content: "";
  position: absolute;
  left: 13px;
  top: 9px;
  width: 26px;
  height: 26px;
  border-left: 6px solid #fff;
  border-bottom: 6px solid #fff;
  transform: rotate(45deg);
  border-radius: 3px;
}

.nav-title {
  flex: 1;
  text-align: center;
  color: #fff;
  font-size: 36px;
  font-weight: 900;
  text-shadow: 0 3px 8px rgba(0, 93, 190, 0.28);
}

.nav-actions {
  width: 170px;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.nav-pill {
  min-width: 72px;
  height: 40px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.95);
  color: #2377df;
  font-size: 22px;
  font-weight: 800;
  box-shadow: 0 8px 18px rgba(23, 99, 200, 0.16);
}

.record-pill {
  color: #0f9af6;
}

.ico-record {
  position: fixed;
  top: 92px;
  right: 0;
  z-index: 20;
  width: 58px;
  height: 220px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: 14px 0 0 14px;
  background: rgba(23, 72, 126, 0.58);
  border: 1px solid rgba(255, 255, 255, 0.28);
  border-right: 0;
  box-shadow: 0 8px 22px rgba(10, 67, 144, 0.2);
  backdrop-filter: blur(3px);
  background-image: none;
}

.ico-record .rule,
.ico-record .record {
  width: 100%;
  min-height: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 22px;
  font-weight: 700;
  line-height: 1.1;
  letter-spacing: 1px;
  text-shadow: 0 2px 4px rgba(0, 52, 120, 0.35);
  writing-mode: vertical-rl;
  text-orientation: upright;
}

.ico-record .rule {
  height: 82px;
  position: relative;
}

.ico-record .rule::before {
  content: "规则";
}

.ico-record .rule::after {
  content: "";
  position: absolute;
  left: 12px;
  right: 12px;
  bottom: 0;
  height: 1px;
  background: rgba(255, 255, 255, 0.52);
}

.ico-record .record {
  flex: 1;
}

.ico-record .record::before {
  content: "购买记录";
}

.activity-panel {
  position: relative;
  z-index: 2;
  margin: -72px 18px 34px;
  padding: 14px 0 34px;
  border-radius: 20px;
  background: #d6e9fd;
  box-shadow: 0 10px 24px rgba(45, 145, 249, 0.16);
}

.time-slots {
  position: relative;
  z-index: 4;
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
  padding: 0 22px 14px;
  margin-top: 0;
  gap: 12px;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  touch-action: pan-x;
  overscroll-behavior-y: contain;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.time-slot {
  flex: 0 0 auto;
  width: 148px;
  min-width: 148px;
  height: 104px;
  touch-action: pan-x;
  border-radius: 16px;
  background-image: none;
  background: linear-gradient(180deg, #fff9ee 0%, #fff4df 100%);
  border: 1px solid rgba(225, 193, 145, 0.55);
  box-shadow: inset 0 -5px 14px rgba(181, 129, 59, 0.08);
  padding-bottom: 0;
  color: #aa8857;
}

.time-slot.active {
  background-image: none;
  background: linear-gradient(180deg, #ff7a3c 0%, #f84842 100%);
  color: #fff;
  border-color: transparent;
  box-shadow: 0 9px 18px rgba(244, 67, 52, 0.28);
}

.time-slot.active::after {
  content: "";
  position: absolute;
  left: 50%;
  bottom: -17px;
  width: 0;
  height: 0;
  transform: translateX(-50%);
  border-left: 17px solid transparent;
  border-right: 17px solid transparent;
  border-top: 18px solid #f84842;
}

.time-label,
.countdown {
  color: inherit;
  font-size: 24px;
  line-height: 1.25;
  font-weight: 700;
}

.time-label span:first-of-type {
  font-size: 28px;
}

.countdown .lable {
  order: -1;
  margin: 0 0 5px;
  font-size: 28px;
}

.countdown .countdown-text,
.countdown.active .countdown-text {
  color: inherit;
  font-size: 21px;
  line-height: 28px;
}

.countdown .countdown-text .frame,
.countdown.active .countdown-text .frame {
  height: 30px;
  min-width: 34px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  background-color: rgba(255, 255, 255, 0.92);
  color: #f44b43;
  padding: 0 3px;
}

.countdown .countdown-text .mao,
.countdown.active .countdown-text .mao {
  color: rgba(255, 255, 255, 0.95);
  font-size: 26px;
  line-height: 30px;
  padding: 0 2px;
}

.support-container {
  position: relative;
  z-index: 1;
  height: 48px;
  margin: 6px 72px 0;
  padding: 0 24px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.54);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.62);
}

.support-container img {
  width: 24px;
  height: 24px;
}

.support-container span {
  color: #1f5dc6;
  font-size: 24px;
  font-weight: 600;
  margin: 0 8px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.coupon-cards {
  padding: 14px 30px 10px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 18px 16px;
  margin-top: 0;
  min-height: 240px;
}

.coupon-card {
  position: relative;
  overflow: visible;
  min-width: 0;
}

.card-content {
  margin-top: 20px;
  min-height: 218px;
  padding: 30px 18px 18px;
  border-radius: 14px;
  background:
    radial-gradient(circle at 86% 48%, rgba(255, 218, 121, 0.26) 0, rgba(255, 218, 121, 0.05) 32%, transparent 58%),
    linear-gradient(180deg, #ffffff 0%, #fffefa 100%);
  box-shadow: 0 10px 20px rgba(33, 129, 220, 0.12);
}

.subsidy-tag {
  top: 0;
  left: 0;
  height: 44px;
  min-width: 105px;
  box-sizing: border-box;
  padding: 8px 14px 12px;
  border-radius: 14px 0 16px 0;
  background-image: none;
  background: linear-gradient(180deg, #ffc33d 0%, #ff9300 100%);
  font-size: 20px;
  line-height: 24px;
  box-shadow: 0 5px 12px rgba(255, 152, 0, 0.25);
}

.subsidy-tag.xianliang {
  background-image: none;
  background: linear-gradient(180deg, #56b9ff 0%, #1476f2 100%);
  height: 44px;
  box-shadow: 0 5px 12px rgba(22, 118, 242, 0.25);
}

.coupon-info {
  height: auto;
  background-image: none;
  cursor: pointer;
}

.total-amount {
  height: 70px;
  color: #ff4b3e;
  justify-content: center;
}

.total-amount .box {
  align-items: baseline;
  line-height: 1;
}

.total-amount .box span:first-child {
  font-size: 30px;
  margin-right: 5px;
}

.total-amount .amount {
  font-size: 64px;
  letter-spacing: 0;
  text-shadow: 0 4px 0 rgba(255, 100, 80, 0.08);
}

.coupon-count {
  height: 34px;
  color: #111;
  font-size: 24px;
  font-weight: 600;
}

.coupon-count .arrow-icon {
  display: none;
}

.gift-balance {
  width: auto;
  height: 32px;
  margin: 9px auto 0;
  padding: 0 8px;
  border: 0;
  background: transparent;
  color: #ff4b3e;
  font-size: 20px;
  font-weight: 700;
}

.coin-icon {
  width: 22px;
  height: 22px;
}

.tag-box {
  height: 32px;
  margin-top: 16px;
  gap: 0;
  flex-wrap: nowrap;
  overflow: hidden;
}

.zhe,
.special-tag {
  height: 30px;
  margin-top: 0;
  border-radius: 4px;
  font-size: 19px;
  flex-shrink: 0;
}

.zhe {
  border: 1px solid #ff604b;
  color: #ff4b3e;
  background-color: #fff;
}

.zhe .tag-icon {
  width: 30px;
  background: linear-gradient(180deg, #ff7742 0%, #f44336 100%);
  color: #fff;
  font-size: 20px;
  padding: 0 6px;
}

.zhe span {
  padding-left: 9px;
  padding-right: 9px;
}

.special-tag {
  margin-left: 5px;
  background: #fff;
  border: 1px solid #ff604b;
  color: #ff4b3e;
  padding: 0 8px;
}

.special-tag img {
  display: none;
}

.price-box {
  margin-top: 12px;
  min-height: 48px;
}

.price-info {
  flex-direction: row;
  align-items: baseline;
  min-width: 0;
}

.current-price {
  color: #ff4b3e;
  font-size: 28px;
  line-height: 1;
  white-space: nowrap;
}

.current-price span:first-of-type {
  font-size: 28px;
}

.original-price {
  margin-left: 14px;
  font-size: 24px;
  color: #9c9c9c;
  white-space: nowrap;
}

.buy-btn,
.buy-btn2 {
  width: 112px;
  height: 48px;
  border: 0;
  border-radius: 999px;
  box-shadow: inset 0 3px 5px rgba(255, 255, 255, 0.32), 0 7px 12px rgba(21, 107, 236, 0.22);
}

.buy-btn {
  background: linear-gradient(180deg, #72d7ff 0%, #1173f2 100%);
}

.buy-btn2 {
  background: linear-gradient(180deg, #e6edf5 0%, #b9c7d8 100%);
  box-shadow: none;
}

.buy-btn span,
.buy-btn2 span {
  font-size: 24px;
  color: #fff;
  font-weight: 900;
}

.more-coupons {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin: 12px 44px 14px;
  color: #2088f6;
  font-size: 24px;
  font-weight: 700;
}

.more-coupons .line {
  height: 1px;
  flex: 1;
  background: linear-gradient(90deg, transparent, rgba(32, 136, 246, 0.55), transparent);
}

.more-coupons .diamonds {
  font-size: 20px;
  letter-spacing: 6px;
}

.more-coupons .more-down-icon {
  width: 30px;
  height: 30px;
  display: block;
  flex: 0 0 auto;
}

.rules-section {
  padding: 0 30px 44px;
}

.rules-content {
  margin-top: 0;
  padding: 34px 28px 30px;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid rgba(255, 255, 255, 0.88);
  box-shadow: 0 10px 22px rgba(46, 135, 211, 0.13);
}

.rule-title {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #155ed2;
  font-size: 30px;
  font-weight: 900;
  margin-bottom: 24px;
}

.rule-title span {
  flex: 0 0 auto;
}

.rule-title-icon {
  width: 54px;
  height: 42px;
  display: block;
  margin: 0 14px;
  flex: 0 0 auto;
}

.rule-list {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.rule-item {
  display: flex;
  align-items: flex-start;
  color: #111;
  font-size: 24px;
  line-height: 1.58;
  font-weight: 600;
}

.rule-num {
  flex: 0 0 auto;
  width: 30px;
  height: 30px;
  margin: 4px 14px 0 0;
  border-radius: 6px;
  background: linear-gradient(180deg, #5caeff 0%, #2475e8 100%);
  color: #fff;
  font-size: 22px;
  line-height: 30px;
  text-align: center;
  font-weight: 900;
  box-shadow: 0 3px 7px rgba(39, 118, 231, 0.25);
}

.coupon-popup-content {
  background: linear-gradient(180deg, #eaf7ff 0%, #fff 42%);
}

.coupon-buy-btn {
  border: 0;
  background: linear-gradient(180deg, #72d7ff 0%, #1173f2 100%);
  box-shadow: 0 10px 18px rgba(21, 107, 236, 0.24);
}

.pay-popup {
  background: linear-gradient(180deg, #f0f9ff 0%, #fff 30%);
}

</style>
